(ns frontend.view.modals.options-management.subs
  (:require [clojure.string :as string]
            [potpuri.core :refer [fn->>]]
            [common.util :as cu]
            [re-frame.core :as rf]
            [frontend.view.modals.error-message.view :as error-message]
            [common.localization :as loc]))

(rf/reg-sub
 ::state
 (fn [db]
   (::state db)))

(rf/reg-sub
 ::named-values
 :<-
 [::state]
 (fn [state _]
   (get-in state [::named-values])))

(defn named-value-labels [named-values _]
  (->> named-values
       (mapv :named-value/value)))

(rf/reg-sub
 ::named-value-labels
 :<-
 [::named-values]
 named-value-labels)

(defn empty-labels? [named-value-labels _]
  (some string/blank? named-value-labels))

(rf/reg-sub
 ::empty-named-values?
 :<-
 [::named-value-labels]
 empty-labels?)

(defn duplicate-named-values [named-value-labels _]
  (->> named-value-labels
       (group-by cu/str-trim-lcase)
       (filter (fn->> second cu/multiple?))
       (mapv second)
       (mapv first)
       seq))

(rf/reg-sub
 ::duplicate-named-values
 :<-
 [::named-value-labels]
 duplicate-named-values)

(rf/reg-sub
 ::errors?
 :<-
 [::empty-named-values?]
 :<-
 [::duplicate-named-values]
 :<-
 [::has-new-changes?]
 (fn [[empty-values? duplicate-values has-new-changes?] _]
   (or empty-values?
       duplicate-values
       (not has-new-changes?))))

(defn error-message
  [[empty-values? duplicate-values has-new-changes?] _]
  (let [non-empty-duplicates (->> duplicate-values
                                  (remove string/blank?)
                                  (mapv string/trim)
                                  seq)]
    (concat
     (when empty-values?
       [(loc/tr :empty-values-not-allowed)])
     (when duplicate-values
       [(str (loc/tr :duplicate-values-not-allowed)
             (when non-empty-duplicates
               (str
                ": "
                (string/join ", " non-empty-duplicates))))])
     (when (not has-new-changes?)
       [(loc/tr :no-changes-made)]))))

(rf/reg-sub
 ::error-messages
 :<-
 [::empty-named-values?]
 :<-
 [::duplicate-named-values]
 :<-
 [::has-new-changes?]
 error-message)

(rf/reg-sub
 ::sorted-named-values
 :<-
 [::named-values]
 (fn [named-values _]
   (->> named-values
        (sort-by :common/ord)
        (vec))))

(rf/reg-sub
 ::pipelines
 :<-
 [::state]
 (fn [state _]
   (get-in state [::pipelines])))

(rf/reg-sub
 ::selected-field
 :<-
 [::state]
 (fn [state _]
   (get-in state [::selected-field])))

(rf/reg-sub
 ::selected-row-id
 :<-
 [::state]
 (fn [state _]
   (get-in state [::selected-row-id])))

(rf/reg-sub
 ::selected-row-ord
 :<-
 [::state]
 (fn [state _]
   (get-in state [::selected-row-ord])))

(rf/reg-sub
 ::selected-named-value
 :<-
 [::named-values]
 :<-
 [::selected-row-id]
 (fn [[named-values selected-row-id] _]
   (->> named-values
        (filter (fn [nv]
                  (= (:db/id nv) selected-row-id)))
        (first))))

(rf/reg-sub
 ::no-row-selected?
 :<-
 [::selected-row-ord]
 (fn [selected-row-ord _]
   (nil? selected-row-ord)))

(rf/reg-sub
 ::merge-disabled?
 :<-
 [::selected-row-id]
 (fn [selected-row-id _]
   (nil? selected-row-id)))

(rf/reg-sub
 ::merge-targets
 :<-
 [::named-values]
 :<-
 [::selected-row-id]
 (fn [[named-values selected-row-id] _]
   (->> named-values
        (remove (fn [value]
                  (= selected-row-id (:db/id value)))))))

(defn comparable-named-values
  [named-values]
  (->> named-values
       (sort-by :common/ord)
       ;;false vs nil comparison:
       (map #(update % :common/archived? boolean))
       ;; #{} vs nil comparison:
       (map #(update % :named-value/archived-in-pipelines set))
       (map (fn [n]
              (select-keys n
                           [:db/id :named-value/value :common/archived?
                            :named-value/archived-in-pipelines])))))

(rf/reg-sub
 ::original-named-values
 :<-
 [::state]
 (fn [state _]
   (get state ::original-named-values)))

(rf/reg-sub
 ::has-new-changes?
 :<-
 [::named-values]
 :<-
 [::original-named-values]
 (fn [[named-values original-named-values] _]
   (not= (comparable-named-values named-values)
         (comparable-named-values original-named-values))))

(rf/reg-sub
 ::saving?
 :<-
 [::state]
 (fn [state _]
   (get state ::saving?)))

(rf/reg-sub
 ::row-dragging-disabled?
 :<-
 [::state]
 (fn [state _]
   (get state ::row-dragging-disabled?)))

(rf/reg-sub
 ::row-to-highlight
 :<-
 [::state]
 (fn [state _]
   (get state ::row-to-highlight)))

(rf/reg-sub
 ::initialized?
 :<-
 [::state]
 (fn [state _]
   (get state ::initialized?)))
